<template>
  <div>
    <el-dialog
      title = "结算详情"
      :visible.sync = "visible"
      :close-on-click-model="false"
      @close="dialogClose"
      append-to-body
      fullscreen
    >
      <div class="name_group">
        <el-select @change="searchDetail" v-model="activeProjectId" size="small" clearable placeholder="订单号">
          <el-option
            v-for="item in settleOption"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <el-button @click="exportShow" icon="el-icon-download" size="small" type="primary">导出</el-button>
      </div>
      <div class="audit-info">
        起草人： {{activePorject.adduser || '-'}}（{{activePorject.addtime}}）审核人：{{ activePorject.checkuser || '-'}} （{{activePorject.checktime}}） 审核说明： {{activePorject.checkmsg}}
      </div>
      <project-detail-table :projectInfo="activePorject" :monthData="monthData" :orderTableData="monthTableData"></project-detail-table>
      <!-- <div class="table_pagination">
        <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
        </el-pagination>
      </div> -->
      <exportDialog :exportDailogFlag.sync="showExport" :projectInfo="activePorject" :projectId="activeProjectId"></exportDialog>
    </el-dialog>
  </div>
</template>
<script>
import { getSettlementList } from '@/api/projectSettlement/summary'
import { getCheckDetailDatas } from '@/api/projectSettlement/procedure'
import { exportOrderList } from '@/services'
import pagination from '@/util/mixins/pagination'
import projectDetailTable from '../projectDetailTable.vue'
import exportDialog from '../summary/exportDialog'
export default {
  mixins: [pagination],
  props: {
    projectDetailFlag: {
      type: Boolean,
      default: false
    },
    projectInfo: {
      type: Object,
      default: () => {}
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  components: {
    exportDialog,
    projectDetailTable
  },
  data() {
    return {
      visible: false,
      activePorject: {},
      activeProjectId: '',
      activeMonth: '0',
      monthData: [],
      monthTableData: [],
      orderData: [],
      showExport: false,
      settledData: [],
      settleOption: [],
      projectName: ''
    }
  },
  mounted () {
  },
  methods: {
    // 审核不通过
    dialogClose() {
      this.$emit('update:projectDetailFlag', false)
    },
    // 获取当月的结算完成列表
    getOptionList () {
      this.listLoading = true
      let postData = {
        startDate: this.projectInfo.month,
        endDate: this.projectInfo.month,
        status: 4,
        current: this.pageNo,
        size: this.pageSize
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.settledData = res.data.data.records
          this.settleOption = this.settledData.map(item => {
            return {
              name: `${item.month}.V${item.version}.${item.name}(已审核)`,
              id: item.id
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      }
      getSettlementList(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 切换项目
    searchDetail(item) {
      this.activePorject = this.settledData.find(it => it.id === item)
      console.log('project check activePorject', this.activePorject)
      this.getList(item)
    },
    // 获取列表
    getList (id) {
      this.listLoading = true
      let postData = {
        settleId: id
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.monthData = res.data.data.monthList
          this.monthTableData = res.data.data.orderRelations
          this.totalEl = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      getCheckDetailDatas(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 显示导出的弹窗
    exportShow () {
      this.showExport = true
    },
    // 导出
    exportList () {
      let postData = {
        reviewCode: 11,
        refundOrderNo: this.refundNo,
        orderId: this.orderNo,
        mobile: this.userAccount,
        reviewTime: this.searchTime,
        refundReviewStatus: this.searchStatus
      }
      exportOrderList(postData)
    }
  },
  watch: {
    projectDetailFlag() {
      this.visible = this.projectDetailFlag
      if(this.visible) {
        this.activeProjectId = this.projectInfo.id
        this.activePorject = this.projectInfo
        this.getList(this.projectInfo.id)
        // 筛选本月的项目
        this.getOptionList()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>